import styled from '@emotion/styled';

const sizes = {
  lg: '16px',
  md: '14px',
  sm: '13px',
  xs: '12px',
};

const lineHeights = {
  lg: '24px',
  md: '21px',
  sm: '18x',
  xs: '16px',
};

const Text = styled.p`
  font-style: normal;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 400)};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : 400)};
  font-size: ${(props) => (props.size ? sizes[props.size] : '16px')};
  line-height: ${(props) => (props.size ? lineHeights[props.size] : '24px')};
  color: ${(props) => (props.color ? props.color : 'var(--text-subdued)')};
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};
`;

export default Text;
